import { DRAW_MODAL, ModalActions, ModalState, REMOVE_MODAL } from './types';

const initialState: ModalState = {
  modalType: undefined,
  modalProps: {},
};

export const modalReducer = (state = initialState, action: ModalActions): ModalState => {
  switch (action.type) {
    case DRAW_MODAL:
      if (!action.modal) {
        return state;
      }

      return {
        ...state,
        modalType: action.modal,
        modalProps: action.props || {},
      };

    case REMOVE_MODAL:
      return {
        ...state,
        modalType: undefined,
        modalProps: {},
      };

    default:
      return state;
  }
};
